import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0f7b827b = () => interopDefault(import('../../../pages/contact-opnemen/index.vue' /* webpackChunkName: "pages/contact-opnemen/index" */))
const _38770ea2 = () => interopDefault(import('../../../pages/contact-opnemen-bedrijf/index.vue' /* webpackChunkName: "pages/contact-opnemen-bedrijf/index" */))
const _a3f7c74a = () => interopDefault(import('../../../pages/informatie-over-rijscholen/index.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/index" */))
const _5b1b5b63 = () => interopDefault(import('../../../pages/contact-opnemen-bedrijf/bevestigd.vue' /* webpackChunkName: "pages/contact-opnemen-bedrijf/bevestigd" */))
const _70a03abc = () => interopDefault(import('../../../pages/contact-opnemen/bevestigd.vue' /* webpackChunkName: "pages/contact-opnemen/bevestigd" */))
const _1b7677f8 = () => interopDefault(import('../../../pages/informatie-over-rijscholen/2todrive.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/2todrive" */))
const _31823f86 = () => interopDefault(import('../../../pages/informatie-over-rijscholen/almere.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/almere" */))
const _33168542 = () => interopDefault(import('../../../pages/informatie-over-rijscholen/amsterdam.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/amsterdam" */))
const _3d7fc33c = () => interopDefault(import('../../../pages/informatie-over-rijscholen/cbr.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/cbr" */))
const _10dc1c26 = () => interopDefault(import('../../../pages/informatie-over-rijscholen/den-haag.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/den-haag" */))
const _ce31c5b2 = () => interopDefault(import('../../../pages/informatie-over-rijscholen/eindhoven.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/eindhoven" */))
const _24563c6c = () => interopDefault(import('../../../pages/informatie-over-rijscholen/groningen.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/groningen" */))
const _a63c1b9a = () => interopDefault(import('../../../pages/informatie-over-rijscholen/haarlem.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/haarlem" */))
const _036586e0 = () => interopDefault(import('../../../pages/informatie-over-rijscholen/nijmegen.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/nijmegen" */))
const _266e4871 = () => interopDefault(import('../../../pages/informatie-over-rijscholen/praktijkexamen.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/praktijkexamen" */))
const _2b55880e = () => interopDefault(import('../../../pages/informatie-over-rijscholen/rijbewijs-a.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/rijbewijs-a" */))
const _2b639f8f = () => interopDefault(import('../../../pages/informatie-over-rijscholen/rijbewijs-b.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/rijbewijs-b" */))
const _43f6aa66 = () => interopDefault(import('../../../pages/informatie-over-rijscholen/rijbewijs-be.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/rijbewijs-be" */))
const _2b71b710 = () => interopDefault(import('../../../pages/informatie-over-rijscholen/rijbewijs-c.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/rijbewijs-c" */))
const _45ab8305 = () => interopDefault(import('../../../pages/informatie-over-rijscholen/rijbewijs-ce.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/rijbewijs-ce" */))
const _2b7fce91 = () => interopDefault(import('../../../pages/informatie-over-rijscholen/rijbewijs-d.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/rijbewijs-d" */))
const _47605ba4 = () => interopDefault(import('../../../pages/informatie-over-rijscholen/rijbewijs-de.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/rijbewijs-de" */))
const _7ec0f5bd = () => interopDefault(import('../../../pages/informatie-over-rijscholen/rijopleiding-in-stappen.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/rijopleiding-in-stappen" */))
const _6170296f = () => interopDefault(import('../../../pages/informatie-over-rijscholen/rotterdam.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/rotterdam" */))
const _06312c8c = () => interopDefault(import('../../../pages/informatie-over-rijscholen/theorie-examen.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/theorie-examen" */))
const _86a1bcbe = () => interopDefault(import('../../../pages/informatie-over-rijscholen/theorie-examen-oefenen.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/theorie-examen-oefenen" */))
const _1cb65ba8 = () => interopDefault(import('../../../pages/informatie-over-rijscholen/tilburg.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/tilburg" */))
const _24c52764 = () => interopDefault(import('../../../pages/informatie-over-rijscholen/tussentijdse-toets.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/tussentijdse-toets" */))
const _19779c26 = () => interopDefault(import('../../../pages/informatie-over-rijscholen/utrecht.vue' /* webpackChunkName: "pages/informatie-over-rijscholen/utrecht" */))
const _d7ffb21c = () => interopDefault(import('../../../pages/offertes-aanvragen/aanvraag-afgerond.vue' /* webpackChunkName: "pages/offertes-aanvragen/aanvraag-afgerond" */))
const _72499224 = () => interopDefault(import('../../../pages/offertes-aanvragen/je-gegevens.vue' /* webpackChunkName: "pages/offertes-aanvragen/je-gegevens" */))
const _bad90388 = () => interopDefault(import('../../../pages/offertes-aanvragen/type-opdracht.vue' /* webpackChunkName: "pages/offertes-aanvragen/type-opdracht" */))
const _dd82738e = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const _861e7d2c = () => interopDefault(import('../../../../../shared/all/page/privacy/PrivacyPage.vue' /* webpackChunkName: "" */))
const _1c6fcb10 = () => interopDefault(import('../../../../../shared/all/page/cookies/CookiesPage.vue' /* webpackChunkName: "" */))
const _0b412bf8 = () => interopDefault(import('../../../../../shared/all/page/termsAndConditions/TermsAndConditionsPage.nl.vue' /* webpackChunkName: "" */))
const _2b1ecb13 = () => interopDefault(import('../../../../../shared/all/themes/blueflow/page/ErrorPage.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contact-opnemen",
    component: _0f7b827b,
    name: "contact-opnemen"
  }, {
    path: "/contact-opnemen-bedrijf",
    component: _38770ea2,
    name: "contact-opnemen-bedrijf"
  }, {
    path: "/informatie-over-rijscholen",
    component: _a3f7c74a,
    name: "informatie-over-rijscholen"
  }, {
    path: "/contact-opnemen-bedrijf/bevestigd",
    component: _5b1b5b63,
    name: "contact-opnemen-bedrijf-bevestigd"
  }, {
    path: "/contact-opnemen/bevestigd",
    component: _70a03abc,
    name: "contact-opnemen-bevestigd"
  }, {
    path: "/informatie-over-rijscholen/2todrive",
    component: _1b7677f8,
    name: "informatie-over-rijscholen-2todrive"
  }, {
    path: "/informatie-over-rijscholen/almere",
    component: _31823f86,
    name: "informatie-over-rijscholen-almere"
  }, {
    path: "/informatie-over-rijscholen/amsterdam",
    component: _33168542,
    name: "informatie-over-rijscholen-amsterdam"
  }, {
    path: "/informatie-over-rijscholen/cbr",
    component: _3d7fc33c,
    name: "informatie-over-rijscholen-cbr"
  }, {
    path: "/informatie-over-rijscholen/den-haag",
    component: _10dc1c26,
    name: "informatie-over-rijscholen-den-haag"
  }, {
    path: "/informatie-over-rijscholen/eindhoven",
    component: _ce31c5b2,
    name: "informatie-over-rijscholen-eindhoven"
  }, {
    path: "/informatie-over-rijscholen/groningen",
    component: _24563c6c,
    name: "informatie-over-rijscholen-groningen"
  }, {
    path: "/informatie-over-rijscholen/haarlem",
    component: _a63c1b9a,
    name: "informatie-over-rijscholen-haarlem"
  }, {
    path: "/informatie-over-rijscholen/nijmegen",
    component: _036586e0,
    name: "informatie-over-rijscholen-nijmegen"
  }, {
    path: "/informatie-over-rijscholen/praktijkexamen",
    component: _266e4871,
    name: "informatie-over-rijscholen-praktijkexamen"
  }, {
    path: "/informatie-over-rijscholen/rijbewijs-a",
    component: _2b55880e,
    name: "informatie-over-rijscholen-rijbewijs-a"
  }, {
    path: "/informatie-over-rijscholen/rijbewijs-b",
    component: _2b639f8f,
    name: "informatie-over-rijscholen-rijbewijs-b"
  }, {
    path: "/informatie-over-rijscholen/rijbewijs-be",
    component: _43f6aa66,
    name: "informatie-over-rijscholen-rijbewijs-be"
  }, {
    path: "/informatie-over-rijscholen/rijbewijs-c",
    component: _2b71b710,
    name: "informatie-over-rijscholen-rijbewijs-c"
  }, {
    path: "/informatie-over-rijscholen/rijbewijs-ce",
    component: _45ab8305,
    name: "informatie-over-rijscholen-rijbewijs-ce"
  }, {
    path: "/informatie-over-rijscholen/rijbewijs-d",
    component: _2b7fce91,
    name: "informatie-over-rijscholen-rijbewijs-d"
  }, {
    path: "/informatie-over-rijscholen/rijbewijs-de",
    component: _47605ba4,
    name: "informatie-over-rijscholen-rijbewijs-de"
  }, {
    path: "/informatie-over-rijscholen/rijopleiding-in-stappen",
    component: _7ec0f5bd,
    name: "informatie-over-rijscholen-rijopleiding-in-stappen"
  }, {
    path: "/informatie-over-rijscholen/rotterdam",
    component: _6170296f,
    name: "informatie-over-rijscholen-rotterdam"
  }, {
    path: "/informatie-over-rijscholen/theorie-examen",
    component: _06312c8c,
    name: "informatie-over-rijscholen-theorie-examen"
  }, {
    path: "/informatie-over-rijscholen/theorie-examen-oefenen",
    component: _86a1bcbe,
    name: "informatie-over-rijscholen-theorie-examen-oefenen"
  }, {
    path: "/informatie-over-rijscholen/tilburg",
    component: _1cb65ba8,
    name: "informatie-over-rijscholen-tilburg"
  }, {
    path: "/informatie-over-rijscholen/tussentijdse-toets",
    component: _24c52764,
    name: "informatie-over-rijscholen-tussentijdse-toets"
  }, {
    path: "/informatie-over-rijscholen/utrecht",
    component: _19779c26,
    name: "informatie-over-rijscholen-utrecht"
  }, {
    path: "/offertes-aanvragen/aanvraag-afgerond",
    component: _d7ffb21c,
    name: "offertes-aanvragen-aanvraag-afgerond"
  }, {
    path: "/offertes-aanvragen/je-gegevens",
    component: _72499224,
    name: "offertes-aanvragen-je-gegevens"
  }, {
    path: "/offertes-aanvragen/type-opdracht",
    component: _bad90388,
    name: "offertes-aanvragen-type-opdracht"
  }, {
    path: "/",
    component: _dd82738e,
    name: "index"
  }, {
    path: "*",
    redirect: {"path":"/"}
  }, {
    path: "/privacy",
    component: _861e7d2c,
    name: "privacy"
  }, {
    path: "/cookies",
    component: _1c6fcb10,
    name: "cookies"
  }, {
    path: "/algemene-voorwaarden",
    component: _0b412bf8,
    name: "algemene-voorwaarden"
  }, {
    path: "/error",
    component: _2b1ecb13,
    name: "error"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
